export enum TrackingVariantETracker {
    SENDORDER = 'sendOrder',
    INSERTTOBASKET = 'insertToBasket',
    WATCHSTEP = 'watchStep',
}